var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
(function(){
  //Finding min and max values in array from http://snippets.dzone.com/posts/show/769
  Array.prototype.min = function(){ return Math.min.apply({},this); };
  Array.prototype.max = function(){ return Math.max.apply({},this); };

  $.fn.masonry = function() {
    this.each(function() {

      var wall = $(this);

      wall.removeAttr('style');

      if ( wall.children().length > 0 ) { // check if the element has anything in it

        var brick = wall.children();
        brick.removeAttr('style');
        var brickW = brick.outerWidth(true);
        var colCount = Math.floor( wall.width() / brickW ) ;

        var colH = [];
        for ( var i = 0; i < colCount; i++) {
          colH[ i ] =  0 ;
        }

        wall.css({ position: 'relative' });

        brick.css({
          float: 'none',
          position: 'absolute',
          display: 'block'
        })
          .each(function(){
            var thisCol;
            for ( i = colCount-1; i > -1; i-- ) {
              if ( colH[ i ] === colH.min() ) {
                thisCol = i;
              }
            }
            $(this).css({
              top: colH[ thisCol ],
              left: brickW * thisCol
            });
            colH[ thisCol ] += $(this).outerHeight(true);
          });

        wall.height( colH.max() );
      }

      return this;
    });
  };
})();
